'use strict';

bbw.directive.longTap = ['$rootScope', '$parse', function($rootScope, $parse) {

    var DEFAULT_DURATION = 600;

    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var tapTimeout;
            var state = 0;
            var prevent = attrs.longTapPrevent;

            function cancelTapTimeout() {
                if (angular.isDefined(tapTimeout)) {
                    clearTimeout(tapTimeout);
                    tapTimeout = undefined;
                }
            }

            function getLongTapDuration() {
                if (attrs.longTapDuration) {
                    var duration = parseInt(scope.$eval(attrs.longTapDuration));
                }
                return duration > 0 ? duration : DEFAULT_DURATION;
            }

            element.on('touchend', function(event) {
                event.stopPropagation();
                event.preventDefault();
                cancelTapTimeout();
                state = -1;
            });

            element.on('touchcancel', function() {
                if (prevent) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                cancelTapTimeout();
                state = -1;
            });

            var test = function() {
                if (!attrs.longTapIf) {
                    return true;
                }
                return scope.$eval(attrs.longTapIf);
            };

            element.on('touchstart', function(event) {
                if (attrs.longTapStart) {
                    var cb = function() {
                        $parse(attrs.longTapStart, null, true)(scope, {$event: event});
                    };
                    if ($rootScope.$$phase) {
                        scope.$evalAsync(cb);
                    } else {
                        scope.$apply(cb);
                    }
                }
                if (prevent) {
                    event.stopPropagation();
                    if (!attrs.longTap) {
                        return;
                    }
                }
                if (state == 1 || !test() || !element[0]) {
                    return;
                }
                state = 1;
                var callback = function() {
                    $parse(attrs.longTap, null, true)(scope, {$event: event});
                };
                var duration = getLongTapDuration();
                var top = element[0].getBoundingClientRect().top;
                tapTimeout = setTimeout(function() {
                    var newTop = element[0].getBoundingClientRect().top;
                    if (state < 1 || newTop != top) {
                        state = 0;
                        return;
                    }
                    state = 0;
                    if ($rootScope.$$phase) {
                        scope.$evalAsync(callback);
                    } else {
                        scope.$apply(callback);
                    }
                }, duration);
            });

            scope.$on('$destroy', cancelTapTimeout);
        }
    }
}];